import React from "react";
import "react-phone-input-2/lib/style.css";

import { formatPhoneNumberWithoutPrefix } from "../../utils/functions";
import { Input } from "../Input/Input";
import classes from "./CustomPhoneInput.module.css";

const CustomPhoneInput = ({
  label = "Contact",
  value,
  setter,
  labelClass,
  disableDropdown = true,
  allCountries = false,
  customStyle,
}) => {
  return (
    <div>
      {label && (
        <p className={[classes.phoneLabel, labelClass && labelClass].join(" ")}>
          {label}
        </p>
      )}
      <Input
        customStyle={{ width: "100%", ...customStyle }}
        placeholder={"Phone"}
        enableSearch={true}
        name="phone"
        value={value}
        setter={(value) => {
          setter(formatPhoneNumberWithoutPrefix(value));
        }}
        disableDropdown={disableDropdown}
      />
    </div>
  );
};

export default CustomPhoneInput;
